import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './AddPetPrompt.css';

const AddPetPrompt = ({ open, onClose }) => {
  const navigate = useNavigate();

  // Close on ESC
  useEffect(() => {
    if (!open) return;
    function onKey(e) {
      if (e.key === 'Escape') {
        if (onClose) onClose();
      }
    }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  function goNow() {
    if (onClose) onClose();
    navigate('/profile/complete');
  }

  function handleClose() {
    if (onClose) onClose();
  }

  return (
    <div className="obp-overlay" role="dialog" aria-modal="true">
      <div className="obp-modal" role="document">
        <button className="obp-x" aria-label="Close" onClick={handleClose}>×</button>

        <h3 className="obp-title">Welcome to Pawsible! 🐾</h3>
        <p className="obp-sub">
            Before we book, let’s add your pet details.
        </p>

        <div className="obp-actions">
          <button className="obp-btn primary" onClick={goNow}>Go to Profile</button>
          <button className="obp-btn secondary" onClick={handleClose}>Not now</button>
        </div>
      </div>
    </div>
  );
};

export default AddPetPrompt;
